<template>
  <node-view-wrapper class="variable">
    {{
      variables?.[node.attrs.id as keyof typeof variables] ??
      `$${node.attrs.id}`
    }}
  </node-view-wrapper>
</template>

<script setup lang="ts">
  import { nodeViewProps, NodeViewWrapper } from "@tiptap/vue-3";

  const props = defineProps(nodeViewProps);

  const { getVariables } = useWebsiteContent();
  const { data: variables } = getVariables();
</script>

<style lang="scss">
  .tiptap {
    .variable {
      display: inline;
    }
  }
</style>
